import React from 'react';

const Badge = ({ children, variant = 'default' }) => {
  const variants = {
    disponible: 'bg-brand-accent/20 text-brand-dark border-brand-accent/50',
    reservado: 'bg-brand-light text-brand-primary border-brand-primary/30',
    ocupado: 'bg-brand-dark text-white border-brand-dark',
    mantenimiento: 'bg-brand-warning/20 text-brand-warning border-brand-warning/50',
    activo: 'bg-green-100 text-green-700 border-green-300',
    inactivo: 'bg-gray-200 text-gray-600 border-gray-300',
    potencial: 'bg-blue-100 text-blue-700 border-blue-300',
    confirmada: 'bg-brand-accent/20 text-brand-dark border-brand-accent/50',
    pendiente: 'bg-yellow-100 text-yellow-700 border-yellow-300',
    pagado: 'bg-brand-accent/20 text-brand-dark border-brand-accent/50',
    abierta: 'bg-brand-alert/20 text-brand-alert border-brand-alert/50',
    resuelta: 'bg-brand-accent/20 text-brand-dark border-brand-accent/50',
    finalizada: 'bg-gray-200 text-gray-700 border-gray-300',
    bloqueado: 'bg-red-100 text-red-700 border-red-300',
    expirado: 'bg-gray-100 text-gray-500 border-gray-200',
    default: 'bg-gray-100 text-gray-700 border-gray-200'
  };

  const currentVariant = variants[variant.toLowerCase()] || variants.default;

  return (
    <span className={`px-2.5 py-0.5 rounded-full text-xs font-medium border ${currentVariant}`}>
      {children}
    </span>
  );
};

export default Badge;